module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MS - Montserrat.9a00cf3a.svg";